import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconLayoutAlignTopBottom: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="layout-align-top-bottom, padding"><path d="M3.75 3.75L20.25 3.75V20.25H3.75L3.75 3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M7 7.75H17" stroke="currentColor" strokeWidth="1.5"/><path d="M7 16.25H17" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconLayoutAlignTopBottom;
